import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminRecruitmentApplications = async (params = {}) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.RECRUITMENT_APPLICATIONS.GET_ALL, { params });
    return response.data;
};

export const getAdminRecruitmentApplicationById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.RECRUITMENT_APPLICATIONS.GET_BY_ID(id));
    return response.data;
};

export const submitCandidateCv = async (formData) => {
    const response = await axiosInstance.post('/recruitment-applications', formData);
    return response.data;
};

export const uploadCandidateCvFile = async (file) => {
    const data = new FormData();
    data.append('file', file);
    const response = await axiosInstance.post('/upload-cv', data, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
};

export const updateAdminRecruitmentApplication = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.RECRUITMENT_APPLICATIONS.UPDATE(id), data);
    return response.data;
};

export const deleteAdminRecruitmentApplication = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.RECRUITMENT_APPLICATIONS.DELETE(id));
    return response.data;
};
